module.exports = __webpack_public_path__ + "media/flags/tt-cdd850a6.svg";